import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Flame } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const inputCls = "bg-[#262D38] border-[#2A313C] focus:border-[#E11D48] focus-visible:ring-[#E11D48]/30 text-white placeholder:text-slate-500 rounded-xl";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center spark-grid-bg px-5">
      <div className="relative w-full max-w-md">
        <Link to="/" className="flex items-center justify-center gap-2 mb-8">
          <span className="flex items-center justify-center w-10 h-10 rounded-xl bg-gradient-to-br from-[#E11D48] to-[#F59E0B]">
            <Flame className="w-5 h-5 text-white" fill="white" />
          </span>
          <span className="font-heading font-extrabold text-xl text-white">Sparkd</span>
        </Link>
        <div className="rounded-2xl border border-[#2A313C] bg-[#1F242D] p-8">
          <h1 className="font-heading text-2xl font-bold text-white">Reset your password</h1>
          {done ? (
            <p className="mt-4 text-slate-300" data-testid="forgot-confirmation">
              If that email is registered, a reset link has been sent. Please check your inbox.
            </p>
          ) : (
            <form onSubmit={submit} className="mt-6 space-y-4" data-testid="forgot-form">
              <p className="text-sm text-slate-400">Enter your staff email and we'll send a reset link.</p>
              <div className="space-y-2">
                <Label htmlFor="email" className="text-slate-300">Email</Label>
                <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@sparkd-app.com" className={inputCls} data-testid="forgot-email" />
              </div>
              {error && <p className="text-sm text-red-400">{error}</p>}
              <Button type="submit" disabled={loading} data-testid="forgot-submit"
                className="w-full rounded-xl py-6 font-semibold bg-gradient-to-r from-[#E11D48] to-[#F59E0B] text-white">
                {loading ? "Sending..." : "Send reset link"}
              </Button>
            </form>
          )}
          <div className="mt-6 text-center">
            <Link to="/staff/login" className="text-sm text-slate-400 hover:text-[#E11D48]">← Back to sign in</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
